import { useState, useCallback } from 'react';

import AccountList from 'components/SwitchAccount/AccountList';
import { useSelector } from 'react-redux';
import { ERROR_IMAGE } from 'settings';
import { If } from 'shared';
import { selectUser } from 'store/selectors';

import { Container } from './styles';

export const UserMenuToolbar = () => {
  const { name, photo } = useSelector(selectUser);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleMenu = useCallback(() => {
    setIsOpen(prev => !prev);
  }, [setIsOpen]);

  return (
    <Container onClick={toggleMenu}>
      <img
        src={photo}
        alt={`${name} imagem`}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = ERROR_IMAGE;
        }}
      />

      <If condition={isOpen}>
        <AccountList position='right' />
      </If>
    </Container>
  );
};
